module.exports = __webpack_public_path__ + "static/web-applications-8592d653bfdab2cf8f855b3cfb259c32.svg";